"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _reactRedirectWidget = require("../../../reactRedirectWidget");

var _tenantSelector = require("../common/tenantSelector");

var actions = _interopRequireWildcard(require("../../../actions"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _radium = _interopRequireWildcard(require("radium"));

var _sdk = require("@mid/sdk");

var _index = _interopRequireDefault(require("../../../containers/impact-login/index"));

var _index2 = _interopRequireDefault(require("../../../containers/impact-login-header/index"));

var _index3 = _interopRequireDefault(require("../../../containers/impact-button/index"));

var _index4 = _interopRequireDefault(require("../../../containers/spinner/index"));

var _rectangle = _interopRequireDefault(require("../../../../assets/img/rectangle.svg"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var getErrorMsgFromState = function getErrorMsgFromState(st) {
  if (st.get(_sdk.PHASE) === _sdk.ST.FAIL) {
    return st.get(_sdk.ERROR_MSG);
  } else {
    return null;
  }
};

var styles = {
  inputLg: {
    margin: '0 0 1rem',
    height: '60px',
    maxWidth: '455px',
    backgroundColor: '#fff',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#e6e8ed',
    fontFamily: 'Open Sans,sans-serif',
    fontSize: '1.07143rem',
    letterSpacing: '.00429rem',
    color: '#888',
    width: '100%',
    padding: '14px 13px',
    borderRadius: 0,
    backgroundImage: "url(".concat(_rectangle.default, ")"),
    backgroundPosition: '109% -22px',
    backgroundSize: '17px 17px',
    backgroundRepeat: 'no-repeat',
    transition: 'background-position .4s ease',
    overflow: 'visible',
    lineHeight: '1.15',
    boxSizing: 'border-box',
    ':focus': {
      backgroundPosition: 'calc(100% - 5px) 5px',
      borderColor: '#888'
    }
  }
};

var LoginComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LoginComponent, _React$Component);

  var _super = _createSuper(LoginComponent);

  function LoginComponent(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, LoginComponent);
    _this = _super.call(this, _props);

    _this.resetDisplay = function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          selectedTenant: null,
          tenantFetch: false
        });
      });
    };

    _this.updateTenants = function (props) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread(_objectSpread({}, prevState), props), {}, {
          tenantFetch: false
        });
      });
    };

    _this.setFailure = function (msg) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          error: true,
          errorMsg: msg,
          tenantFetch: false
        });
      });
    };

    _this.removeFailure = function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          error: false,
          errorMsg: null,
          tenantFetch: false
        });
      });
    };

    _this.singleTenantSelect = function (tenant) {
      _this.state.selectedTenant = tenant;

      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {
          selectedTenant: tenant
        });
      });
    };

    _this.selectTenant = function (tenant) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          selectedTenant: tenant
        });
      });

      _this.state.selectTenantResolver(tenant); // this.state.mid.core.loginWidget.loginButtonComponent.updateTenants({tenant});

    };

    var errorMsg = getErrorMsgFromState(_props.mid.core.state);

    var tenantFetch = _props.mid.core.state.get(_sdk.PHASE) === _sdk.ST.TENANT_FETCH;

    _this.state = _objectSpread(_objectSpread({}, _props), {}, {
      st: _props.mid.core.state,
      initialized: false,
      error: !!errorMsg,
      tenantFetch: tenantFetch,
      errorMsg: errorMsg
    });
    _this.state.mid.core.loginWidget.loginComponent = (0, _assertThisInitialized2.default)(_this);
    _this.showEmail = true;

    _this.state.mid.core.loginWidget.transition(_this.state.mid.core.state);

    return _this;
  }

  (0, _createClass2.default)(LoginComponent, [{
    key: "renderErrors",
    value: function renderErrors() {
      if (!this.state.error) return /*#__PURE__*/_react.default.createElement("span", null);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-selector": "mid-error"
      }, this.state.errorMsg);
    }
  }, {
    key: "renderEmailEntryDialog",
    value: function renderEmailEntryDialog() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        "data-selector": "mid-email",
        style: styles.inputLg,
        placeholder: "Email",
        type: "email",
        id: "email",
        onChange: function onChange(ev) {
          var v = ev.target.value;
          delete _this2.state.selectedTenant;
          delete _this2.state.tenantError;
          delete _this2.state.tenants;

          _this2.setState(function (prevState) {
            return (0, _reactRedirectWidget.reactWidgetStateProcessor)(prevState, actions.updateEmail({
              email: v
            }));
          });
        },
        onKeyPress: function onKeyPress(ev) {
          if (ev.key === 'Enter') {
            ev.preventDefault();

            _this2.setState(function (prevState) {
              return (0, _reactRedirectWidget.reactWidgetStateProcessor)(prevState, actions.submitEmail());
            });
          }
        }
      }), this.renderErrors(), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index3.default, {
        data_selector: "continue-login",
        onClick: function onClick(ev) {
          ev.preventDefault();

          _this2.setState(function (prevState) {
            return (0, _reactRedirectWidget.reactWidgetStateProcessor)(prevState, actions.submitEmail());
          });
        },
        defaultLabel: "Continue"
      }), this.state.tenantError ? /*#__PURE__*/_react.default.createElement("div", {
        "data-selector": "no-tenants-found-err",
        className: 'error'
      }, "No Tenants Found") : null));
    }
  }, {
    key: "renderTenantSelector",
    value: function renderTenantSelector() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "impact-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "im-form-group-lg impact-col-6"
      }, /*#__PURE__*/_react.default.createElement(_tenantSelector.TenantSelectorComponent, {
        cls: this.state.mid.core.loginWidget,
        tenants: this.state.tenants,
        selectTenantResolver: this.state.selectTenantResolver,
        sendTenant: this.selectTenant,
        selectedTenant: this.state.selectedTenant,
        resetDisplay: this.resetDisplay,
        mode: this.state.mid.core.mode
      })));
    }
  }, {
    key: "render",
    value: function render() {
      this.showEmail = !(this.state.tenants && this.state.tenants.length > 0);

      if (this.state.tenantFetch) {
        return /*#__PURE__*/_react.default.createElement(_radium.StyleRoot, null, /*#__PURE__*/_react.default.createElement(_index.default, null, /*#__PURE__*/_react.default.createElement(_index4.default, null)));
      }

      return /*#__PURE__*/_react.default.createElement(_radium.StyleRoot, null, /*#__PURE__*/_react.default.createElement(_index.default, null, this.props.customHeader ? /*#__PURE__*/_react.default.createElement(this.props.customHeader, null) : /*#__PURE__*/_react.default.createElement(_index2.default, null), this.showEmail ? this.renderEmailEntryDialog() : this.renderTenantSelector()));
    }
  }]);
  return LoginComponent;
}(_react.default.Component);

LoginComponent.propTypes = {
  mid: _propTypes.default.object,
  customHeader: _propTypes.default.func
};

var _default = (0, _radium.default)(LoginComponent);

exports.default = _default;